import { LANGUAGES, REGIONS } from './types';

export const regionSupportedLanguages = {
  [REGIONS.US]: new Set([LANGUAGES.en]),
  [REGIONS.CA]: new Set([LANGUAGES.fr, LANGUAGES.en]),
};
